export default __webpack_public_path__ + "static/media/image09.6d4432a0.jpg";